import React from "react";
import moment from "moment-timezone";
import $ from "jquery";
import { format } from "react-string-format";

const DocumentHistoryPopup = ({
  modalForDocumentHistory,
  selectedLanguage,
  handlermodalForDocumentHistory,
  fileName,
  lstDocumentsHistoryDetails,
  dateFormatValueUpper,
  handleVersionHisrtyPageLevel,
  handleTermOfservicePopup,
  isDatetimeControl,
  applyTimeZoneToDisplay,
  timeZoneRef,
  timeZoneAbbrevation,
  handleVersionHistoryCanPrint,
}) => {
  if (!modalForDocumentHistory) return null;
  function rowclickHistory(event) {
    $(event.target).closest("tr").next(".fold").toggleClass("open");
    $(event.target).closest("tr").toggleClass("open");
  }


  function displayAuthType(authType) {
    if (authType.toLowerCase() === "email") {
      return selectedLanguage.LstLanguageCodes.UI_Email;
    } else if (authType.toLowerCase() === "text") {
      return selectedLanguage.LstLanguageCodes.UI_Text;
    } else if (authType.toLowerCase() === "both") {
      return (
        selectedLanguage.LstLanguageCodes.UI_Email +
        ", " +
        selectedLanguage.LstLanguageCodes.UI_Text
      );
    }
    return "";
  }

  return (
    <div className="modalCus documentversion-history" id="myModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="card-body pt-1 pb-0">
            <div
              className="mb-2 mt-3 justify-content-between d-flex"
              style={{ borderBottom: "2px solid #918d8d4d" }}>
              <h4 htmlFor="">
                <p className="fw-bold">
                  {
                    selectedLanguage.LstLanguageCodes
                      .UI_DocumentversionHistory
                  }
                </p>
              </h4>
              <button
                type="button"
                className="btn btn-outline-danger modalclose download"
                onClick={(e) => handlermodalForDocumentHistory()}>
                <span className="material-icons font-20">
                  highlight_off
                </span>
              </button>
            </div>
            <div className="row">
              <div className="input-group field mt-1 res-nowwrap ">
                <p
                  className="fw-bold text-word-break"
                  style={{
                    fontSize: "17px",
                    marginBottom: "0px !important",
                  }}>
                  {selectedLanguage.LstLanguageCodes.UI_DocumentName}:{" "}
                  {fileName}
                </p>
              </div>
            </div>
          </div>

          <div
            className="card-body pt-0"
            style={{
              maxHeight: "350px",
              overflow: "auto",
              overflowX: "hidden",
              display: "block",
              paddingRight: "3px",
              marginRight: "10px",
            }}>
            <div className="table-responsive res-card">
              <table
                className="fold-table table tablelayout "
                cellPadding="0"
                cellSpacing="0">
                <thead className="bg-lightblue">
                  <tr className="">
                    <th className="" style={{ width: "19%" }}>
                      {selectedLanguage.LstLanguageCodes.UI_versionNo}
                    </th>
                    <th className="" style={{ width: "33%" }}>
                      {selectedLanguage.LstLanguageCodes.UI_UpdatedTime + " " + "(" + timeZoneAbbrevation.current + ")"}
                    </th>
                    <th className="">
                      {selectedLanguage.LstLanguageCodes.UI_UpdatedBy}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* <!-------- First one ---------> */}

                  {lstDocumentsHistoryDetails.length > 0 &&
                    lstDocumentsHistoryDetails.map((item, i) => (
                      <tr className="borderrow">
                        <td colSpan={8} className="innertTableTd">
                          <table
                            className="popupDocumentHistory"
                            cellPadding="0"
                            cellSpacing="0">
                            <tr
                              className="view"
                              onClick={rowclickHistory}
                              id={"trMain" + i}>
                              <td
                                className="text-start"
                                style={{
                                  width: "19%",
                                  borderleft: "0.1rem solid #e7e5e570",
                                }}>
                                <div className="d-flex flex-wrap textwrap">
                                  {"V" +
                                    (lstDocumentsHistoryDetails.length - i)}
                                </div>
                              </td>
                              <td
                                className="text-start"
                                style={{
                                  width: "33%",
                                  borderLeft: "0.1rem solid #e7e5e570",
                                }}>
                                <div className="d-flex flex-wrap textwrap">
                                  {item.modified != null
                                    ? (moment.utc(
                                      applyTimeZoneToDisplay(
                                        new Date(item.modified),
                                        timeZoneRef.current
                                      ))
                                    ).format(dateFormatValueUpper + " HH:mm")
                                    : moment.utc(
                                      applyTimeZoneToDisplay(
                                        new Date(item.created),
                                        timeZoneRef.current
                                      )
                                    ).format(dateFormatValueUpper + " HH:mm")}
                                </div>
                              </td>
                              <td className="text-start" style={{ borderLeft: "0.1rem solid #e7e5e570" }}>
                                <div
                                  className="d-flex flex-wrap "
                                  title={item.modifiedBy}>
                                  <p className="textwrap mb-0">
                                    {" "}
                                    {item.modifiedBy}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr className="fold" id={"trChailed" + i}>
                              <td colSpan="8">
                                <div className="">
                                  <div
                                    className=""
                                    style={{ width: "100%" }}>
                                    <table className="table table-borderless tableHistorydetails">
                                      <tbody>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_AccessControl
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              {item.securityLevel === 3 ? (
                                                <span
                                                  style={{
                                                    marginLeft: "-5px",
                                                  }}
                                                  className={
                                                    item.isSecuritylevelChanged ==
                                                      true
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {" "}
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_LimitReaders
                                                  }
                                                </span>
                                              ) : item.securityLevel ===
                                                2 ? (
                                                <span
                                                  style={{
                                                    marginLeft: "-2px",
                                                  }}
                                                  className={
                                                    item.isSecuritylevelChanged ==
                                                      true
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_TrackReaders
                                                  }
                                                </span>
                                              ) : (
                                                <span
                                                  style={{
                                                    marginLeft: "-5px",
                                                  }}
                                                  className={
                                                    item.isSecuritylevelChanged ==
                                                      true
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {" "}
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_TrackViews
                                                  }
                                                </span>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Status
                                              }
                                              :{" "}
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isDocumentEnabled ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .enabled === true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Active
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Expired}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Launches
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              {isDatetimeControl === "false" ? (
                                                <span
                                                  className={
                                                    item.isStartTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.startTime == null ||
                                                    item.documentOptions.startTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(new Date(item.documentOptions.startTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper) +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              ) : (
                                                <span
                                                  className={
                                                    item.isStartTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.startTime == null ||
                                                    item.documentOptions.startTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(
                                                        new Date(item.documentOptions.startTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper + " HH:mm") +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              )}
                                            </div>
                                          </td>

                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Expires
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              {isDatetimeControl === "false" ? (
                                                <span
                                                  className={
                                                    item.isExpiryTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.expiryTime == null ||
                                                    item.documentOptions.expiryTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(
                                                        new Date(item.documentOptions.expiryTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper) +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              ) : (
                                                <span
                                                  className={
                                                    item.isExpiryTimeValueChanged === true ? "highlight" : ""
                                                  }
                                                >
                                                  {item.documentOptions.expiryTime == null ||
                                                    item.documentOptions.expiryTime === ""
                                                    ? ""
                                                    : moment.utc(
                                                      applyTimeZoneToDisplay(
                                                        new Date(item.documentOptions.expiryTime),
                                                        timeZoneRef.current
                                                      )
                                                    ).format(dateFormatValueUpper + " HH:mm") +
                                                    " " +
                                                    "(" + timeZoneAbbrevation.current + ")"}
                                                </span>
                                              )}
                                            </div>
                                          </td>

                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_RestrictToDomains
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isDomainsValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {
                                                  item.documentOptions
                                                    .domains
                                                }
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_AllowedIP
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            {item.documentOptions.ips
                                              .length > 0 &&
                                              item.documentOptions.ips.map(
                                                (ips, j) => (
                                                  <div className="d-flex flex-wrap ">
                                                    <span
                                                      className={
                                                        item.isIpsValueChanged ==
                                                          true
                                                          ? "highlight"
                                                          : ""
                                                      }>
                                                      {ips}{" "}
                                                    </span>
                                                  </div>
                                                )
                                              )}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxReadsperReader
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxReadsValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxReads === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxReads}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxviewsPerDocument
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxViewsPerDocumentValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxViewsPerDocument === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxViewsPerDocument}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_AllowResponsesTo
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isAllowResponsesToValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {
                                                  item.documentOptions
                                                    .allowResponsesTo
                                                }
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_SendVerificationCode
                                              }
                                              :
                                            </span>
                                          </td>
                                          {item.securityLevel !== 1 && (
                                            <td className="ColHistory">
                                              <div className="d-flex flex-wrap textwrap">
                                                <span
                                                  className={
                                                    (item.isSMSChanged ==
                                                      true || item.isEmailChanged == true || (item.isSMSChanged == true && item.isEmailChanged == true))
                                                      ? "highlight"
                                                      : ""
                                                  }>
                                                  {(item.documentOptions
                                                    .isSMS && item.documentOptions.isEmail)
                                                    ? `${selectedLanguage.LstLanguageCodes.UI_Email}, ${selectedLanguage.LstLanguageCodes.UI_Text}`
                                                    : item.documentOptions.isSMS
                                                      ? `${selectedLanguage.LstLanguageCodes.UI_Text}`
                                                      : item.documentOptions.isEmail
                                                        ? `${selectedLanguage.LstLanguageCodes.UI_Email}`
                                                        : ``
                                                  }
                                                </span>
                                              </div>
                                            </td>
                                          )}
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Watermark
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isWaterValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .watermark === 1
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Confidential
                                                  : item.documentOptions
                                                    .watermark === 2
                                                    ? selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_Draft
                                                    : item.documentOptions
                                                      .watermark === 3
                                                      ? selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_MyLogo
                                                      : selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_None}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_BannedRegions
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isBannedRegionValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.regions}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_TimeStamp
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isTimestampValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .timestamp == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_CanPrint
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.iscanPrintValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .print == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                              {item.documentOptions.print === true && (
                                                <a className={item.iscanPrintView === true && item.documentOptions.recipients.length > 0 ? "bgYellow pointer" : "pointer"}
                                                  style={{ padding: "0px 5px 1px 5px", }}
                                                  onClick={() => handleVersionHistoryCanPrint(item.id)}>
                                                  {selectedLanguage.LstLanguageCodes.UI_View}
                                                </a>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxPrintsPerReader
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxPrintsPerReaderChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxPrintsPerReader === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxPrintsPerReader}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_MaxPrintsPerDocument
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isMaxPrintsPerDocumentChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .maxPrintsPerDocument === 0
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Unlimited
                                                  : item.documentOptions
                                                    .maxPrintsPerDocument}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_DisplayDistributionlist
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isDistributionListValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .distributionList == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Voting
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isVotingValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .voting == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_ShareVotes
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isVoteSharingValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .voteSharing == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_Pagelevelrestrictions
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isPageLevelRestrictionChanged ===
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .pageLevelRestriction ==
                                                  true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>{" "}
                                              <span>
                                                {" "}
                                                {item.isPageLevelRestrictionVarForView ===
                                                  true && (
                                                    <a
                                                      className={
                                                        item.isPageLevelRestrictionViewHighligte
                                                          ? "bgYellow pointer"
                                                          : "pointer"
                                                      }
                                                      style={{
                                                        padding:
                                                          "0px 5px 1px 5px",
                                                      }}
                                                      onClick={() =>
                                                        handleVersionHisrtyPageLevel(
                                                          item.id
                                                        )
                                                      }>
                                                      {
                                                        selectedLanguage
                                                          .LstLanguageCodes
                                                          .UI_View
                                                      }
                                                    </a>
                                                  )}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_IDLeakers
                                              }
                                              :{" "}
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="d-flex flex-wrap textwrap">
                                              <span
                                                className={
                                                  item.isSteganographyValueChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .steganography == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="ColHistory">
                                            <span>
                                              {
                                                selectedLanguage
                                                  .LstLanguageCodes
                                                  .UI_EDisclosure
                                              }
                                              :
                                            </span>
                                          </td>
                                          <td className="ColHistory">
                                            <div className="">
                                              <span
                                                className={
                                                  item.isEDisclosureChanged ==
                                                    true
                                                    ? "highlight"
                                                    : ""
                                                }>
                                                {item.documentOptions
                                                  .eDisclosure == true
                                                  ? selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Enabled
                                                  : selectedLanguage
                                                    .LstLanguageCodes
                                                    .UI_Disabled}
                                              </span>
                                              {" "}
                                              {item.documentOptions.eDisclosure ?
                                                <span>
                                                  <a className="pointer"
                                                    style={{
                                                      padding:
                                                        "0px 5px 1px 5px",
                                                    }}

                                                    onClick={() => handleTermOfservicePopup(item.eDisclosureTermsOfService
                                                    )}
                                                  >
                                                    {
                                                      selectedLanguage
                                                        .LstLanguageCodes
                                                        .UI_View
                                                    }
                                                  </a></span> : ""}
                                            </div>
                                          </td>
                                        </tr>
                                        <>
                                          {item.securityLevel === 3 ||
                                            (item.isPageLevelRestrictionVarForView &&
                                              item.isDistributionsChanged) ? (
                                            <tr>
                                              <td className="ColHistory">
                                                <span>
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_NewAutherizedReaders
                                                  }
                                                  :
                                                </span>
                                              </td>
                                              <td className="ColHistory">
                                                <div className="d-flex flex-wrap textwrap">
                                                  {/* <span
                                                        className={
                                                          item.isDistributionsChanged ==
                                                          true
                                                            ? "highlight"
                                                            : ""
                                                        }
                                                      > */}
                                                  {item.distributionChangedEmails !=
                                                    null &&
                                                    item
                                                      .distributionChangedEmails
                                                      .length > 0 &&
                                                    item.distributionChangedEmails.map(
                                                      (data, j) =>
                                                        j > 0 ? (
                                                          <span
                                                            className={
                                                              item.isDistributionsChanged ==
                                                                true
                                                                ? "highlight"
                                                                : ""
                                                            }>
                                                            {" "}
                                                            {data.firstName !=
                                                              "" &&
                                                              data.lastName ==
                                                              ""
                                                              ? data.firstName +
                                                              "<" +
                                                              data.email +
                                                              ">" +
                                                              displayAuthType(data?.authType ?? "") +
                                                              ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                              : data.firstName ==
                                                                "" &&
                                                                data.lastName !=
                                                                ""
                                                                ? data.lastName +
                                                                "<" +
                                                                data.email +
                                                                ">" +
                                                                displayAuthType(data?.authType ?? "") +
                                                                ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                : data.firstName !=
                                                                  "" &&
                                                                  data.lastName !=
                                                                  ""
                                                                  ? data.firstName +
                                                                  " " +
                                                                  data.lastName +
                                                                  "<" +
                                                                  data.email +
                                                                  ">" +
                                                                  displayAuthType(data?.authType ?? "") +
                                                                  ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                  : data.email + " " +
                                                                  displayAuthType(data?.authType ?? "") +
                                                                  ` ${data.mobileCountryCode} ${data.mobileNumber}`}
                                                            {data.reference?.trim() !== "" ? ` ${data.reference}` : ""}
                                                          </span>
                                                        ) : (
                                                          <span
                                                            className={
                                                              item.isDistributionsChanged ==
                                                                true
                                                                ? "highlight"
                                                                : ""
                                                            }>
                                                            {" "}
                                                            {data.firstName !=
                                                              "" &&
                                                              data.lastName ==
                                                              ""
                                                              ? data.firstName +
                                                              "<" +
                                                              data.email +
                                                              ">" +
                                                              displayAuthType(data?.authType ?? "") +
                                                              ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                              : data.firstName ==
                                                                "" &&
                                                                data.lastName !=
                                                                ""
                                                                ? data.lastName +
                                                                "<" +
                                                                data.email +
                                                                ">" +
                                                                displayAuthType(data?.authType ?? "") +
                                                                ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                : data.firstName !=
                                                                  "" &&
                                                                  data.lastName !=
                                                                  ""
                                                                  ? data.firstName +
                                                                  " " +
                                                                  data.lastName +
                                                                  "<" +
                                                                  data.email +
                                                                  ">" +
                                                                  displayAuthType(data?.authType ?? "") +
                                                                  ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                  : data.email + " " + displayAuthType(data?.authType ?? "") +
                                                                  ` ${data.mobileCountryCode} ${data.mobileNumber}`}
                                                            {data.reference?.trim() !== "" && data.reference}
                                                          </span>
                                                        )
                                                    )}
                                                  {/* </span> */}
                                                </div>
                                              </td>
                                            </tr>
                                          ) : (
                                            ""
                                          )}
                                          {item.securityLevel === 3 ||
                                            item.securityLevel === 2 ? (
                                            <tr>
                                              <td className="ColHistory">
                                                <span>
                                                  {
                                                    selectedLanguage
                                                      .LstLanguageCodes
                                                      .UI_ModifiedReaders
                                                  }
                                                  :
                                                </span>
                                              </td>
                                              <td className="ColHistory">
                                                <div className="">
                                                  {item.lstDocumentRecipientDto !=
                                                    null &&
                                                    item
                                                      .lstDocumentRecipientDto
                                                      .length > 0 &&
                                                    item.lstDocumentRecipientDto.map(
                                                      (data, j) =>
                                                        data.enabled ==
                                                          true ? (
                                                          <div className="d-flex flex-wrap">
                                                            <span
                                                              className={
                                                                item.isDocumentRecipientEnabled ==
                                                                  true
                                                                  ? "highlight"
                                                                  : ""
                                                              }>
                                                              {data.firstName !=
                                                                "" &&
                                                                data.lastName ==
                                                                ""
                                                                ? data.firstName +
                                                                "<" +
                                                                data.email +
                                                                ">" +
                                                                displayAuthType(data?.authType ?? "") +
                                                                (data.isMobileNumOrCountryCodeModified &&
                                                                  data.mobileCountryCode &&
                                                                  data.mobileNumber
                                                                  ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                  : "") +
                                                                (data.isFirstorLastModified !=
                                                                  true &&
                                                                  !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                  ? " (" +
                                                                  selectedLanguage
                                                                    .LstLanguageCodes
                                                                    .UI_Active +
                                                                  ")"
                                                                  : "")
                                                                : data.firstName ==
                                                                  "" &&
                                                                  data.lastName !=
                                                                  ""
                                                                  ? data.lastName +
                                                                  "<" +
                                                                  data.email +
                                                                  ">" +
                                                                  displayAuthType(data?.authType ?? "") +
                                                                  (data.isMobileNumOrCountryCodeModified &&
                                                                    data.mobileCountryCode &&
                                                                    data.mobileNumber
                                                                    ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                    : "") +
                                                                  (data.isFirstorLastModified !=
                                                                    true &&
                                                                    !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                    ? " (" +
                                                                    selectedLanguage
                                                                      .LstLanguageCodes
                                                                      .UI_Active +
                                                                    ")"
                                                                    : "")
                                                                  : data.firstName !=
                                                                    "" &&
                                                                    data.lastName !=
                                                                    ""
                                                                    ? data.firstName +
                                                                    " " +
                                                                    data.lastName +
                                                                    "<" +
                                                                    data.email +
                                                                    ">" +
                                                                    displayAuthType(data?.authType ?? "") +
                                                                    (data.isMobileNumOrCountryCodeModified &&
                                                                      data.mobileCountryCode &&
                                                                      data.mobileNumber
                                                                      ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                      : "") +
                                                                    (data.isFirstorLastModified !=
                                                                      true &&
                                                                      !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                      ? " (" +
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_Active +
                                                                      ")"
                                                                      : "")
                                                                    : data.email + " " + displayAuthType(data?.authType ?? "") +
                                                                    (data.isMobileNumOrCountryCodeModified &&
                                                                      data.mobileCountryCode &&
                                                                      data.mobileNumber
                                                                      ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                      : "") +
                                                                    (data.isFirstorLastModified !=
                                                                      true &&
                                                                      !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true &&
                                                                      (!data.isAuthTypeChanged)
                                                                      ? " (" +
                                                                      selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_Active +
                                                                      ")"
                                                                      : "")} {data.reference?.trim() !== "" ? ` ${data.reference}` : ""}
                                                            </span>
                                                          </div>
                                                        ) : (
                                                          <div className="d-flex flex-wrap">
                                                            <span
                                                              className={
                                                                item.isDocumentRecipientEnabled ==
                                                                  true
                                                                  ? "highlight"
                                                                  : ""
                                                              }>
                                                              {data.firstName !=
                                                                "" &&
                                                                data.lastName ==
                                                                ""
                                                                ? data.firstName +
                                                                "<" +
                                                                data.email +
                                                                ">" +
                                                                displayAuthType(data?.authType ?? "") +
                                                                (data.isMobileNumOrCountryCodeModified &&
                                                                  data.mobileCountryCode &&
                                                                  data.mobileNumber
                                                                  ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                  : "") +
                                                                (data.isFirstorLastModified !=
                                                                  true &&
                                                                  !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                  ? " (" +
                                                                  (data.status ==
                                                                    "Pause"
                                                                    ? selectedLanguage.LstLanguageCodes.UI_Pause.trim()
                                                                    : selectedLanguage
                                                                      .LstLanguageCodes
                                                                      .UI_Banned) +
                                                                  ")"
                                                                  : "")
                                                                : data.firstName ==
                                                                  "" &&
                                                                  data.lastName !=
                                                                  ""
                                                                  ? data.lastName +
                                                                  "<" +
                                                                  data.email +
                                                                  ">" +
                                                                  displayAuthType(data?.authType ?? "") +
                                                                  (data.isMobileNumOrCountryCodeModified &&
                                                                    data.mobileCountryCode &&
                                                                    data.mobileNumber
                                                                    ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                    : "") +
                                                                  (data.isFirstorLastModified !=
                                                                    true &&
                                                                    !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                    ? " (" +
                                                                    (data.status ==
                                                                      "Pause"
                                                                      ? selectedLanguage.LstLanguageCodes.UI_Pause.trim()
                                                                      : selectedLanguage
                                                                        .LstLanguageCodes
                                                                        .UI_Banned) +
                                                                    ")"
                                                                    : "")
                                                                  : data.firstName !=
                                                                    "" &&
                                                                    data.lastName !=
                                                                    ""
                                                                    ? data.firstName +
                                                                    " " +
                                                                    data.lastName +
                                                                    "<" +
                                                                    data.email +
                                                                    ">" +
                                                                    displayAuthType(data?.authType ?? "") +
                                                                    (data.isMobileNumOrCountryCodeModified &&
                                                                      data.mobileCountryCode &&
                                                                      data.mobileNumber
                                                                      ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                      : "") +
                                                                    (data.isFirstorLastModified !=
                                                                      true &&
                                                                      !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                      ? " (" +
                                                                      (data.status ==
                                                                        "Pause"
                                                                        ? selectedLanguage.LstLanguageCodes.UI_Pause.trim()
                                                                        : selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Banned) +
                                                                      ")"
                                                                      : "")
                                                                    : data.email + " " + displayAuthType(data?.authType ?? "") +
                                                                    (data.isMobileNumOrCountryCodeModified &&
                                                                      data.mobileCountryCode &&
                                                                      data.mobileNumber
                                                                      ? ` ${data.mobileCountryCode} ${data.mobileNumber}`
                                                                      : "") +
                                                                    (data.isFirstorLastModified !=
                                                                      true &&
                                                                      !data.isMobileNumOrCountryCodeModified && data.isReferenceModified != true
                                                                      && !data.isAuthTypeChanged
                                                                      ? " (" +
                                                                      (data.status ==
                                                                        "Pause"
                                                                        ? selectedLanguage.LstLanguageCodes.UI_Pause.trim()
                                                                        : selectedLanguage
                                                                          .LstLanguageCodes
                                                                          .UI_Banned) +
                                                                      ")"
                                                                      : "")}
                                                              {data.reference?.trim() !== "" ? ` ${data.reference}` : ""}
                                                            </span>
                                                          </div>
                                                        )
                                                    )}
                                                </div>
                                              </td>
                                            </tr>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="row mt-3 d-flex align-items-center justify-content-between">
              <p className="w-auto">
                {format(
                  selectedLanguage.LstLanguageCodes.UI_Showing1to12,
                  1,
                  lstDocumentsHistoryDetails.length,
                  lstDocumentsHistoryDetails.length
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentHistoryPopup;
